export enum TimeSlot {
  MORNING = 'Morning (8AM-12PM)',
  AFTERNOON = 'Afternoon (12PM-4PM)',
  EVENING = 'Evening (4PM-8PM)',
  NOT_AVAILABLE = 'Not Available',
} 